export const initialData = 
    [
        0,
        0,
        12880.65,
        74887.88,
        205408.28999999998,
        410936.13999999996,
        655225.5,
        918889.77,
        1182554.04,
        1446218.31,
        1709882.58,
        1973546.85,
        2237211.12,
        2500875.39,
        2764539.66,
        3028203.93,
        3291868.2,
        3555532.47,
        3819196.74,
        4082861.0100000002,
        4346525.28,
        4610189.550000001,
        4873853.82,
        5137518.09,
        5401182.359999999,
        5664846.629999999,
        5928510.8999999985,
        6192175.169999998,
        6455839.439999998,
        6719503.709999997,
        6983167.979999997,
        7246832.249999996,
        7510496.519999996,
        7774160.789999995,
        8037825.059999995,
        8301489.3299999945,
        8565153.599999994,
        8828817.869999994
    ]
